module.exports = __webpack_public_path__ + "img/agreement_txt.3d2ae63b.png";